import { PaperReferralApprovalResult } from '@dreryk/egabinet-referral-frontend-api';
import { VisitReferralToSpecialistApproveCommand } from '@dreryk/egabinet-visit-frontend-api';

import { useCqrsCommand, UseCqrsCommandResult } from '@dreryk/command-query-react-common';

import { useReferralPrintCommandSuccessHandler } from '../../shared/useReferralPrintCommandSuccessHandler';
import { ReferralToSpecialistFormBean } from '../ReferralToSpecialistForm/ReferralToSpecialistForm.types';

import { mapReferralToSpecialistFormBeanToReferralCommandDetails } from './ReferralToSpecialistSendAction.utils';

export const useReferralToSpecialistConfirmAndPrintCommand = (
   visitId: number,
   onSuccess: VoidFunction
): UseCqrsCommandResult<PaperReferralApprovalResult, ReferralToSpecialistFormBean> => {
   const handleSuccess = useReferralPrintCommandSuccessHandler({
      visitId: visitId,
      onPrintDone: onSuccess,
   });

   return useCqrsCommand<PaperReferralApprovalResult, ReferralToSpecialistFormBean>(
      (parameters) => {
         const command = new VisitReferralToSpecialistApproveCommand();
         command.visitId = visitId;
         command.referralDetails = mapReferralToSpecialistFormBeanToReferralCommandDetails(parameters, false);
         return command;
      },
      {
         onSuccess: handleSuccess,
      }
   );
};
